import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/tools.png'


const _hoisted_1 = { id: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "image avatar" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "tools"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h1", { id: "logo" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Kim Hebert")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Owner/Mechanic"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://goo.gl/maps/hm6hXh2gnsTV1QuWA" }, "2053 Atchafalaya River Hwy")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://goo.gl/maps/hm6hXh2gnsTV1QuWA" }, "Breaux Bridge, LA 70515")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "tel:337-322-1966" }, "337-322-1966")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("nav", { id: "nav" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#one",
        class: "active"
      }, "About")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "#two" }, "Repairs")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "#four" }, "Contact")
    ])
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
}